export const VEBPlanCodes2024 = [
	"80328",
	"80613",
	"80984",
	"80985",
	"81012",
	"81013",
	"81014",
	"AI-ALL-2024",
	"CA-ALL-2024",
	"CI-ALL-2024",
	"DR-ALL-2024",
	"DT-ALL-2024",
	"FP-ALL-2024",
	"GLI-ALL-2024",
	"HI-ALL-2024",
	"STD-ALL-2024",
	"VI-ALL-2024",
	"WL-ALL-2024"
];

export const VEBPlanCodes2025 = [
	"80328", //Plan Code for Accident - Accident Only Rider
	"80613", //Plan Code for Whole life - Child Term Rider
	"80984", //Plan Code for Cancer - Intensive Care Unit Rider
	"80985", //Plan Code for Cancer - Intensive Care Unit Rider
	"81012", //Plan Code for Accident - Accident and Sickness Rider
	"81013", //Plan Code for Accident - Accident and Sickness Rider
	"81014", //Plan Code for Accident - Accident and Sickness Rider
	"AI-ALL-2025",
	"CA-ALL-2025",
	"CI-ALL-2025",
	"DR-ALL-2025",
	"DT-ALL-2025",
	"FP-ALL-2025",
	"GLI-ALL-2025",
	"HI-ALL-2025",
	"STD-ALL-2025",
	"VI-ALL-2025",
	"WL-ALL-2025"
];
